import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useContext } from "react";
import { AppContext } from "./AppContext";
import { Filters } from "./Filters";

export const FiltersModal: React.FC = () => {
  const { showFilters, setShowFilters } = useContext(AppContext);

  const onClose = () => {
    setShowFilters(false);
  };

  return (
    <>
      <Transition appear show={showFilters} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto bg-opacity-40 transition-all bg-black"
          onClose={onClose}
        >
          <div className="min-h-screen p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="relative inline-block w-full max-w-md my-6 text-left align-middle transition-all transform bg-offwhite shadow paragraph">
                <button
                  type="button"
                  className="inline-block absolute top-2 right-3 text-2xl"
                  onClick={onClose}
                >
                  <i className="fal fa-times"></i>
                </button>
                <div className="p-4 md:p-6">
                  <Dialog.Title as="h3" className="heading-3 mb-5">
                    Filter venues
                  </Dialog.Title>
                  <Filters />
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
